import React, { useState, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { useNavigate } from 'react-router-dom';

const RequestPasswordReset: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const navigate = useNavigate();
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    await fetch(
      'https://api.gommaire-client-zone.yournewwebsite.be/request-password-reset.php',
      {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: email,
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.message === 'success') {
          setSent(true);
        } else {
          setError(data.error);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        // Handle network or server errors
        console.log(error);
      });
  };

  return (
    <div className="flex flex-col min-h-screen px-5 py-12 bg-gray-100 fade-in lg:justify-center lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img
          src="/Gommaire-logo.png"
          alt="Logo"
          className="w-auto h-32 mx-auto cursor-pointer md:h-44"
          onClick={() => navigate('/')}
        />
        <h2 className="mt-5 text-xl font-normal text-center text-gray-900">
          Request password reset
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="px-4 py-8 bg-white shadow sm:rounded-lg sm:px-10">
          {!sent ? (
            <form className="space-y-6" onSubmit={handleSubmit}>
              <div>
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700"
                >
                  Email address
                </label>
                <div className="mt-1">
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    className="block w-full px-3 py-2 placeholder-gray-400 border border-gray-300 rounded-md shadow-sm appearance-none focus:outline-none focus:ring-[#e9e9e5] focus:border-[#e9e9e5] sm:text-sm"
                  />
                </div>
              </div>
              <div className="text-sm">
                <Link
                  to="/login"
                  className="flex items-center font-medium text-default hover:text-[#e9e9e5]"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-4 h-4 mr-1"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                    />
                  </svg>
                  <span> To login page</span>
                </Link>
              </div>
              {loading ? (
                <div className="flex justify-center">
                  <svg
                    className="inline-blockmt-5 w-9 h-9 text-accent animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </div>
              ) : (
                <div>
                  <button
                    type="submit"
                    className="flex justify-center w-full px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-default hover:bg-[#e9e9e5] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#e9e9e5]"
                  >
                    Submit
                  </button>
                  <p className="mt-2 text-sm font-medium text-red-600">
                    {error}
                  </p>
                </div>
              )}
            </form>
          ) : (
            <>
              <p className="text-lg font-medium text-center text-green-600">
                A password reset link has been sent to your e-mail address
              </p>
              <button
                onClick={() => navigate('/login')}
                className="flex justify-center inline-block w-auto px-4 py-2 mx-auto mt-5 text-sm font-medium text-white bg-default border border-transparent rounded-md shadow-sm hover:bg-[#e9e9e5] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#e9e9e5]"
              >
                To login page
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RequestPasswordReset;
